<app-header></app-header> 

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">Portfolio Three</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<!-- Portfolio section -->
<div class="section-lg">
    <div class="container">
        <div class="row portfolio-grid g-4 g-lg-5 border-radius">
            <div *ngFor="let item of portfolioItems" class="col-12 col-md-6 portfolio-item img-class" [ngClass]="item.categoryClass">
        
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img [src]="item.image" [alt]="item.title">
                    </div>
        
                    <a routerLink="/portfolio-one"></a>
        
                    <div class="portfolio-title">
                        <div>
                            <h4>{{ item.title }}</h4>
                            <span>{{ item.category }}</span>
                        </div>
                    </div>
                </div>
        
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Sliding Text -->
<section class="section-sm">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->